import React from "react";
import { useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex";
import CreditForm from "../CreditForm/CreditForm";
import { PaymentCreditOption } from "../types/ProjectCredit";

const FORM_ID = "credit-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
  paymentCredits: PaymentCreditOption[];
}

const New: React.FC<Props> = ({
  projectId,
  permission,
  projectStatus,
  paymentCredits,
}) => {
  const navigate = useNavigate();
  const canSave =
    (permission === "create" || permission === "manage") &&
    projectStatus === "building";

  return (
    <AdminFormPage
      title="Add Payment Credit"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() =>
        navigate(`/projects/${projectId}/project_credits`, {
          state: null,
        })
      }
    >
      <CreditForm
        formId={FORM_ID}
        projectId={projectId}
        paymentCredits={paymentCredits}
      />
    </AdminFormPage>
  );
};

export default New;
